import { CLEAN_YUNO, CLEAN_YUNO_ERROR } from '_models/redux/types';

export const cleanYunoAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_YUNO,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_YUNO_ERROR,
    });
  }
};
